/* eslint-disable no-magic-numbers, class-methods-use-this */
import Phase from '../phase-core/Phase';

const hum = [
	[20, -30],
	[30, -35],
	[40, -40],
	[50, -45],
	[60, -50],
	[70, -55],
];

export default class LowHum extends Phase.Config {

	run({ period, feedback_opts }) {
		feedback_opts.master_level = 0.6;
		feedback_opts.feedback_level = 0.1;
		feedback_opts.speed = period;
		feedback_opts.spectrum = new Map(hum);
	}

}
